<template>
  <g>
    <path
      d="M20.41 9.00025C20.9 9.00025 21.1 8.37025 20.7 8.09025L13.15 2.80025C12.46 2.32025 11.54 2.32025 10.86 2.80025L3.30002 8.09025C2.90002 8.37025 3.10002 9.00025 3.59002 9.00025H11V21.0002C11 21.5502 11.45 22.0002 12 22.0002C12.55 22.0002 13 21.5502 13 21.0002V9.00025H20.41Z"
    />
    <path
      d="M8.00001 16.0003H4.90001L4.33001 12.9803C4.23001 12.4403 3.71001 12.0803 3.16001 12.1803C2.62001 12.2803 2.26001 12.8003 2.36001 13.3503L3.00001 16.7403V21.0003C3.00001 21.5503 3.45001 22.0003 4.00001 22.0003H4.01001C4.56001 22.0003 5.01001 21.5603 5.01001 21.0103L5.02001 18.0003H7.00001V21.0003C7.00001 21.5503 7.45001 22.0003 8.00001 22.0003C8.55001 22.0003 9.00001 21.5503 9.00001 21.0003V17.0003C9.00001 16.4503 8.55001 16.0003 8.00001 16.0003Z"
    />
    <path
      d="M20.84 12.1803C20.3 12.0803 19.78 12.4403 19.67 12.9803L19.1 16.0003H16C15.45 16.0003 15 16.4503 15 17.0003V21.0003C15 21.5503 15.45 22.0003 16 22.0003C16.55 22.0003 17 21.5503 17 21.0003V18.0003H18.98L19 21.0103C19 21.5603 19.45 22.0003 20 22.0003C20.55 22.0003 21 21.5503 21 21.0003V16.7403L21.64 13.3503C21.74 12.8103 21.38 12.2803 20.84 12.1803Z"
    />
  </g>
</template>
